import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%'
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingXSmall,
    color: $theme.colors.black,
    marginTop: 0,
    marginBottom: $theme.sizing.scale700
}))

export const Subtitle = styled('h2', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    color: $theme.colors.black,
    margin: 0
}))

export const InfoContainer = styled<'div', { $divider: boolean }>('div', ({ $theme, $divider }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: $theme.sizing.scale600,
    width: '100%'
}))

export const InfoItem = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    ...$theme.typography.ParagraphMedium
}))

export const PriceContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flexDirection: 'column'
}))

export const Price = styled('span', ({ $theme }) => ({
    ...$theme.typography.HeadingXLarge,
    color: $theme.colors.black,
    margin: 0
}))

export const PriceVat = styled('span', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    color: $theme.colors.black,
    margin: 0
}))
